import React from 'react';
import { Row, Col, Card } from 'react-bootstrap';
import { QRCode } from 'react-qr-code';
import PropTypes from 'prop-types';
import { useToast } from 'context/providers/ToastProvider';
import { Link } from 'react-router-dom';

const SellosDigitales = ({ datosSellos, value }) => {
    const { showSuccessToast, showErrorToast } = useToast();

    const copyToClipboard = async (text) => {
        try {
            await navigator.clipboard.writeText(text);
            showSuccessToast('Copiado');
        } catch (err) {
            console.error('Failed to copy: ', err);
            showErrorToast('Error al copiar');
        }
    };


    return (
        <>
            <Row className="mb-4">
                <Col md={12}>
                    <Card className="border-2 shadow-sm">
                        <Card.Body className="p-3">
                            <Card.Title className="fw-bold mb-3">SELLO DIGITAL DEL CFDI</Card.Title>
                            <div className="mb-3">
                                <p className="text-break  mb-4" >
                                    {datosSellos.SelloCFD}
                                </p>
                            </div>
                            <Row className="mb-3 border-top pt-3">
                                <Col md={4}>
                                    <h6 className="fw-bold mb-2">FOLIO FISCAL</h6>
                                    <Link style={{ cursor: 'pointer' }} onClick={() => copyToClipboard(datosSellos.UUID)} to={"#"}>{datosSellos.UUID}</Link>
                                </Col>
                                <Col md={4}>
                                    <h6 className="fw-bold mb-2">CERTIFICADO SAT</h6>
                                    <p >{datosSellos.NoCertificadoSAT}</p>
                                </Col>
                                <Col md={4}>
                                    <h6 className="fw-bold mb-2">FECHA DE TIMBRADO</h6>
                                    <p >{datosSellos.FechaTimbrado}</p>
                                </Col>
                            </Row>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
            <Row>
                <Col md={9}>
                    <div className="mb-3">
                        <h6 className="fw-bold mb-2">SELLO DIGITAL SAT:</h6>
                        <p className="text-break mb-4" >
                            {datosSellos.SelloSAT}
                        </p>
                    </div>
                    <div className="mb-3">
                        <h6 className="fw-bold mb-2">
                            CADENA ORIGINAL DEL COMPLEMENTO DE CERTIFICACIÓN DIGITAL DEL SAT:
                        </h6>
                        <p className="text-break  mb-3">
                            {datosSellos.certificacionSat}
                        </p>
                    </div>
                </Col>
                <Col xs={3} md={6} lg={4} xl={3} className="text-end">
                    <QRCode value={value} size={256} level="H" />
                </Col>
            </Row>
        </>
    );
};

SellosDigitales.propTypes = {
    datosSellos: PropTypes.object,
    value: PropTypes.string,
};

export default SellosDigitales;